import axios from "axios";
import envConfig from "./EnvironmentConfigs";

const ApiClient = axios.create({
    baseURL: envConfig.apiBaseUrl
});

ApiClient.interceptors.request.use(injectAccessToken);
ApiClient.interceptors.response.use(handleSuccessResponse, handleErrorResponse);

async function injectAccessToken(config) {
    config.headers.Authorization = `Bearer ${sessionStorage.getItem('kc_token')}`;

    return {
        ...config
    };
}

export default ApiClient;

function handleSuccessResponse(response) {
    return response;
}

function handleErrorResponse(error) {
    const status = error?.response?.status ?? null;

    if (status === 401) {
        sessionStorage.setItem('session_expired', 'true');
        const currentPath = `${window.location.pathname}${window.location.search}`;
        if (currentPath && currentPath !== '/') {
            sessionStorage.setItem('post_login_redirect', currentPath);
        }
        sessionStorage.removeItem('kc_token');
        sessionStorage.removeItem('kc_refresh_token');
        sessionStorage.removeItem('kc_id_token');
        sessionStorage.removeItem('kc_session');

        if (window.location.pathname !== '/') {
            window.location.assign('/');
        }
    }

    return Promise.reject(error);
}
